import React, { useMemo } from 'react';

import { getCountryCallingCode } from 'react-phone-number-input';

import CustomSelect, { CustomSelectOption } from '../Select';

import styles from './SelectPhoneField.module.scss';

const SelectPhoneField = ({ options, ...props }: any) => {
	const opts: CustomSelectOption[] = useMemo(() => {
		return options
			.filter((i: any) => i.value)
			.map((option: any) => {
				const flagImg = (
					<img
						width={24}
						src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${option.value}.svg`}
						alt={option.value}
					/>
				);

				return {
					...option,
					labelInHead: (
						<div className={styles.option}>
							{flagImg} +{getCountryCallingCode(option.value)}
						</div>
					),
					label: `${option.label} +${getCountryCallingCode(option.value)}`,
					labelJSX: (
						<div className={styles.option}>
							{flagImg} {option.label} <span>+{getCountryCallingCode(option.value)}</span>
						</div>
					),
				};
			});
	}, [options]);

	return (
		<div className={styles.SelectPhoneField}>
			<CustomSelect options={opts} {...props} />
		</div>
	);
};

export default SelectPhoneField;
